import { render } from "./Feed.vue.js?vue&type=template&id=2f1ce8e4!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=template&id=2f1ce8e4"
import script from "./Feed.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/Feed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f1ce8e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f1ce8e4', __exports__)) {
    api.reload('2f1ce8e4', __exports__)
  }
  
  module.hot.accept("./Feed.vue.js?vue&type=template&id=2f1ce8e4!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Feed.vue?vue&type=template&id=2f1ce8e4", () => {
    api.rerender('2f1ce8e4', render)
  })

}


export default __exports__